export default "__VITE_PUBLIC_ASSET__ac3356f8__"